export default [
  {
    path: "/inicio",
    name: "home",
    meta: {
      resource: "Home",
      action: "read",
    },
    component: () => import("@/views/pages/index.vue"),
  },
  {
    path: "/login:access_token?",
    name: "auth-login",
    component: () => import("@/views/pages/login.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      redirectIfLoggedIn: true,
    },
  },
  {
    path: "/auth",
    name: "auth-login-query",
    component: () => import("@/views/pages/loginToken.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      redirectIfLoggedIn: true,
    },
  },
  {
    path: "/error-404",
    name: "error-404",
    component: () => import("@/views/error/Error404.vue"),
    meta: {
      resource: "Auth",
      action: "read",
    },
  },
  {
    path: "/not-authorized",
    name: "misc-not-authorized",
    component: () => import("@/views/error/Error403.vue"),
    meta: {
      resource: "Auth",
      action: "read",
    },
  },
  {
    path: "/center",
    name: "center",
    meta: {
      resource: "Center",
      action: "read",
    },
    component: () => import("@/views/center/Index.vue"),
  },
  {
    path: "/sector",
    name: "sector",
    meta: {
      resource: "Sector",
      action: "read",
    },
    component: () => import("@/views/sector/Index.vue"),
  },
  {
    path: "/camera_manager/master_account",
    name: "master_account",
    meta: {
      resource: "CameraManager",
      action: "read_masters_accounts",
    },
    component: () => import("@/views/camera_manager/master_account/Index.vue"),
  },
  {
    path: "/camera_manager/reseller/:id_master_account?",
    name: "reseller",
    meta: {
      resource: "CameraManager",
      action: "read_resellers",
    },
    component: () => import("@/views/camera_manager/reseller/Index.vue"),
  },
  {
    path: "/camera_manager/camera/:id_reseller?",
    name: "camera",
    meta: {
      resource: "CameraManager",
      action: "read",
    },
    component: () => import("@/views/camera_manager/camera/Index.vue"),
  },
  {
    path: "/bridge/camera/:id_bridge?",
    name: "bridge_camera",
    meta: {
      resource: "Bridge",
      action: "read",
    },
    component: () => import("@/views/bridge/camera/Index.vue"),
  },
  {
    path: "/bridge/bridge/:id_account?",
    name: "bridge",
    meta: {
      resource: "Bridge",
      action: "read_accounts",
    },
    component: () => import("@/views/bridge/bridge/Index.vue"),
  },
  {
    path: "/bridge/account/:id_master_account?",
    name: "account",
    meta: {
      resource: "Bridge",
      action: "read_bridge",
    },
    component: () => import("@/views/bridge/account/Index.vue"),
  },
  {
    path: "/bridge/master_account",
    name: "bridge_master_account",
    meta: {
      resource: "Bridge",
      action: "read_masters_accounts",
    },
    component: () => import("@/views/bridge/master_account/Index.vue"),
  },
  {
    path: "/tenant/:id_master_tenant?",
    name: "tenant",
    meta: {
      resource: "Tenant",
      action: "read",
    },
    component: () => import("@/views/tenant/Index.vue"),
  },
  {
    path: "/incident/:id_tenant?",
    name: "incident",
    meta: {
      resource: "Incident",
      action: "read",
    },
    component: () => import("@/views/tenant/incident/Index.vue"),
  },
  {
    path: "/chart/incident",
    name: "incident_chart",
    meta: {
      resource: "Incident",
      action: "read_chart",
    },
    component: () => import("@/views/tenant/incident/Charts.vue"),
  },
  {
    path: "/master_tenant",
    name: "master_tenant",
    meta: {
      resource: "MasterTenant",
      action: "read",
    },
    component: () => import("@/views/master_tenant/Index.vue"),
  },
  {
    path: "/bookmark-categories",
    name: "bookmark",
    meta: {
      resource: "Video",
      action: "manage_request_record_video",
    },
    component: () => import("@/views/recording_request/tag/Index.vue"),
  },
  {
    path: "/user",
    name: "user",
    meta: {
      resource: "User",
      action: "read",
    },
    component: () => import("@/views/user/Index.vue"),
  },
  {
    path: "/profile",
    name: "profile",
    meta: {
      resource: "Profile",
      action: "read",
    },
    component: () => import("@/views/profile/Index.vue"),
  },
  /*{
    path: "/router",
    name: "router",
    meta: {
      resource: "Router",
      action: "read",
    },
    component: () => import("@/views/router/Index.vue"),
  },*/
  {
    path: "/permission",
    name: "permission",
    meta: {
      resource: "Permission",
      action: "read",
    },
    component: () => import("@/views/permission/Index.vue"),
  },
  {
    path: "/logs",
    name: "logs",
    meta: {
      resource: "Log",
      action: "read",
    },
    component: () => import("@/views/logs/Index.vue"),
  },
  {
    path: "/action-plan",
    name: "action-plan",
    meta: {
      resource: "ActionPlan",
      action: "read",
    },
    component: () => import("@/views/action_plan/Index.vue"),
  },
  {
    path: "/action-plan/config/:id_action_plan?",
    name: "actionPlanConfig",
    meta: {
      resource: "ActionPlan",
      action: "read",
    },
    component: () => import("@/views/action_plan/Config.vue"),
  },
  {
    path: "/unit",
    name: "unit",
    meta: {
      resource: "Units",
      action: "read",
    },
    component: () => import("@/views/unit/Index.vue"),
  },
  {
    path: "/traffic",
    name: "traffic",
    meta: {
      resource: "Log",
      action: "read",
    },
    component: () => import("@/views/traffic/Index.vue"),
  },
  {
    path: "/omnicloud_camera",
    name: "omnicloud_camera",
    meta: {
      resource: "CameraOmnicloud",
      action: "read",
    },
    component: () => import("@/views/vxg_camera/camera/Index.vue"),
  },
  {
    path: "/securos_camera",
    name: "securos_camera",
    meta: {
      resource: "CameraSecuros",
      action: "read",
    },
    component: () => import("@/views/securos_camera/camera/Index.vue"),
  },
  {
    path: "/presets",
    name: "presets",
    meta: {
      resource: "CameraBridge",
      action: "read_presets",
    },
    component: () => import("@/views/preset/Index.vue"),
  },
  {
    path: "/buttons",
    name: "buttons",
    meta: {
      resource: "Button",
      action: "read",
    },
    component: () => import("@/views/buttons/Index.vue"),
  },
  {
    path: "/button_type",
    name: "button_type",
    meta: {
      resource: "Button",
      action: "read",
    },
    component: () => import("@/views/button_type/Index.vue"),
  },
  {
    path: "/status_cameras",
    name: "status_cameras",
    meta: {
      resource: "CameraManager",
      action: "read_status",
    },
    component: () => import("@/views/status_cameras/Index.vue"),
  },
  {
    path: "/seproban/events",
    name: "seproban_events",
    meta: {
      resource: "SeprobanRequest",
      action: "read",
    },
    component: () => import("@/views/seproban/seproban_events/Index.vue"),
  },
  {
    path: "/seproban/images/:id_event",
    name: "seproban_images",
    meta: {
      resource: "SeprobanRequest",
      action: "read",
    },
    component: () => import("@/views/seproban/seproban_images/Index.vue"),
  },
  {
    path: "/tokens_omnitag",
    name: "tokens_omnitag",
    meta: {
      resource: "TokenOmnitag",
      action: "read",
    },
    component: () => import("@/views/tokens_omnitag/Index.vue"),
  },
  {
    path: "/alarm/:filter?",
    name: "alarm",
    props: true,
    meta: {
      resource: "Alarm",
      action: "read_history",
    },
    component: () => import("@/views/alarm/Index.vue"),
  },
  {
    path: "/group",
    name: "group",
    meta: {
      resource: "Group",
      action: "read",
    },
    component: () => import("@/views/group/Index.vue"),
  },
  {
    path: "/user_profile/",
    name: "user_profile",
    meta: {
      resource: "User",
      action: "read_profile",
    },
    component: () => import("@/views/user_profile/AccountSetting.vue"),
  },
  {
    path: "/plate_list",
    name: "plate_list",
    meta: {
      resource: "PlateList",
      action: "read",
    },
    component: () => import("@/views/plate_list/Index.vue"),
  },
  {
    path: "/plate",
    name: "plate",
    meta: {
      resource: "Plate",
      action: "read",
    },
    component: () => import("@/views/plate/Index.vue"),
  },
  {
    path: "/lpr_matches",
    name: "lpr_matches",
    meta: {
      resource: "Lpr",
      action: "read_match",
    },
    component: () => import("@/views/lpr_matches/Index.vue"),
  },
  {
    path: "/luxriot_master_accounts",
    name: "luxriot_master_accounts",
    meta: {
      resource: "Lpr",
      action: "read_match",
    },
    component: () => import("@/views/luxriot/luxriot_master_accounts/Index.vue"),
  },
  {
    path: "/luxriot_cameras",
    name: "luxriot_cameras",
    meta: {
      resource: "Lpr",
      action: "read_match",
    },
    component: () => import("@/views/luxriot/luxriot_cameras/Index.vue"),
  },
  {
    path: "/facial_recognition/:person_id?",
    name: "facial_recognition",
    meta: {
      resource: "FaceRecognition",
      action: "read_match",
    },
    component: () => import("@/views/facial_recognition/Index.vue"),
  },
  {
    path: "/incident_list",
    name: "incident_list",
    meta: {
      resource: "Incident",
      action: "read",
    },
    component: () => import("@/views/incident_list/Index.vue"),
  },
  {
    path: "/swift_account",
    name: "swift_account",
    meta: {
      resource: "Swift",
      action: "read_account",
    },
    component: () => import("@/views/swift_account/Index.vue"),
  },
  {
    path: "/swift_collector",
    name: "swift_collector",
    meta: {
      resource: "Swift",
      action: "read_collector",
    },
    component: () => import("@/views/swift_collector/Index.vue"),
  },
  {
    path: "/swift_sensor",
    name: "swift_sensor",
    meta: {
      resource: "Swift",
      action: "read_sensor",
    },
    component: () => import("@/views/swift_sensor/Index.vue"),
  },
  // Layout builder
  {
    path: "/layouts",
    name: "layouts",
    meta: {
      resource: "Layouts",
      action: "read",
    },
    component: () => import("@/views/layout_builder/Index.vue"),
  },
  {
    path: "/layouts/config-layout/:id_layout?",
    name: "configLayout",
    meta: {
      resource: "Layouts",
      action: "read",
    },
    component: () => import("@/views/layout_builder/layoutConfig.vue"),
  },
  {
    path: "/alarm-views",
    name: "alarm_views",
    meta: {
      resource: "AlarmViews",
      action: "read",
    },
    component: () => import("@/views/alarm_views/Index.vue"),
  },
  {
    path: "/alarm-views/config-view/:id_view?",
    name: "configAlarmView",
    meta: {
      resource: "AlarmViews",
      action: "read",
    },
    component: () => import("@/views/alarm_views/Config.vue"),
  },
  {
    path: "/video-watermarks",
    name: "video_watermarks",
    meta: {
      resource: "Layouts",
      action: "read",
    },
    component: () => import("@/views/video_watermarks/Index.vue"),
  },
  {
    path: "/video-watermarks/config/:id_video_watermark?",
    name: "configVideoWatermark",
    meta: {
      resource: "Layouts",
      action: "read",
    },
    component: () => import("@/views/video_watermarks/Config.vue"),
  },
  {
    path: "/device-tags",
    name: "device_tags",
    meta: {
      resource: "Tenant",
      action: "read",
    },
    component: () => import("@/views/device_tags/Index.vue"),
  },
  {
    path: "/distribution-list",
    name: "distribution_list",
    meta: {
      resource: "DistributionList",
      action: "read",
    },
    component: () => import("@/views/tenant/distribution/Index.vue"),
  },
  {
    path: "/token",
    name: "token",
    meta: {
      resource: "Token",
      action: "read",
    },
    component: () => import("@/views/token/Index.vue"),
  },
  {
    path: "/recording_request",
    name: "recording_request",
    meta: {
      resource: "Video",
      action: "request_record_video",
    },
    component: () => import("@/views/recording_request/recording/Index.vue"),
  },
  {
    path: "/recording_request/create",
    name: "recording_request_create",
    meta: {
      resource: "Video",
      action: "request_record_video",
    },
    component: () => import("@/views/recording_request/recording/FormRecordingRequest.vue"),
  },
  {
    path: "/recording_request/:id/edit",
    name: "recording_request_edit",
    meta: {
      resource: "Video",
      action: "request_record_video",
    },
    component: () => import("@/views/recording_request/recording/FormRecordingRequest.vue"),
  },
  {
    path: "/show_recording/:id_recording",
    name: "show_recording",
    meta: {
      resource: "Video",
      action: "request_record_video",
    },
    component: () => import("@/views/recording_request/show_recording/Index.vue"),
  },
  {
    path: "/alarm_comment",
    name: "alarm_comment",
    meta: {
      resource: "Recording",
      action: "read",
    },
    component: () => import("@/views/alarm_comment/Index.vue"),
  },
  {
    path: "/user_cameras",
    name: "user_cameras",
    meta: {
      resource: "User",
      action: "update_cameras",
    },
    component: () => import("@/views/user_cameras/Index.vue"),
  },
  {
    path: "/group_cameras",
    name: "group_cameras",
    meta: {
      resource: "Group",
      action: "update_cameras",
    },
    component: () => import("@/views/group_cameras/Index.vue"),
  },
  {
    path: "/plane/:id",
    name: "plane",
    meta: {
      resource: "Units",
      action: "read",
    },
    component: () => import("@/views/plane/Index.vue"),
  },
  {
    path: "/users_app",
    name: "users_app",
    meta: {
      resource: "UsersApp",
      action: "read_users_app",
    },
    component: () => import("@/views/users_app/Index.vue"),
  },
  {
    path: "/reset_password/:token/:id",
    name: "reset_password",
    meta: {
      layout: "full",
      resource: "Auth",
      action: "read",
    },
    component: () => import("@/views/users_app/ResetPassword.vue"),
  },
  {
    path: "/person_list",
    name: "person_list",
    meta: {
      resource: "PersonList",
      action: "read",
    },
    component: () => import("@/views/person_list/Index.vue"),
  },
  {
    path: "/access_devices",
    name: "access_devices",
    meta: {
      resource: "AccessDevices",
      action: "read",
    },
    component: () => import("@/views/access_devices/Index.vue"),
  },
  {
    path: "/safr_events",
    name: "safr_events",
    meta: {
      resource: "FaceRecognition",
      action: "read",
    },
    component: () => import("@/views/safr/safr_events/Index.vue"),
  },
  {
    path: "/safr_groups",
    name: "safr_groups",
    meta: {
      resource: "FaceRecognition",
      action: "read",
    },
    component: () => import("@/views/safr/safr_groups/Index.vue"),
  },
  {
    path: "/safr_master_accounts",
    name: "safr_master_accounts",
    meta: {
      resource: "PersonList",
      action: "read",
    },
    component: () => import("@/views/safr/safr_master_accounts/Index.vue"),
  },
  {
    path: "/safr_cameras",
    name: "safr_cameras",
    meta: {
      resource: "PersonList",
      action: "read",
    },
    component: () => import("@/views/safr/safr_cameras/Index.vue"),
  },
  {
    path: "/safr_people",
    name: "safr_people",
    meta: {
      resource: "FaceRecognition",
      action: "read",
    },
    component: () => import("@/views/safr/safr_people/Index.vue"),
  },
  {
    path: "/safr_access_clearances",
    name: "safr_access_clearances",
    meta: {
      resource: "PersonList",
      action: "read",
    },
    component: () => import("@/views/safr/safr_access_clearances/Index.vue"),
  },
  {
    path: "/workflow",
    name: "workflow",
    meta: {
      resource: "Workflow",
      action: "read",
    },
    component: () => import("@/views/workflow/Index.vue"),
  },
  {
    path: "/schedule_task",
    name: "schedule_task",
    meta: {
      resource: "ScheduleTask",
      action: "read",
    },
    component: () => import("@/views/schedule_task/Index.vue"),
  },
  {
    path: "/user_shared_tenant",
    name: "user_shared_tenant",
    meta: {
      resource: "User",
      action: "update_cameras",
    },
    component: () => import("@/views/user_shared_tenant/Index.vue"),
  },
  {
    path: "/group_shared_tenant/:id_group/:group",
    name: "group_shared_tenant",
    meta: {
      resource: "Group",
      action: "update_shared_tenant",
    },
    component: () => import("@/views/group_shared_tenant/Index.vue"),
  },
  {
    path: "/iotcomms_master_account",
    name: "iotcomms_master_account",
    meta: {
      resource: "IotcommsMasterAccount",
      action: "read",
    },
    component: () => import("@/views/iotcomms/master_account/Index.vue"),
  },
  {
    path: "/type_device_interphone",
    name: "type_device_interphone",
    meta: {
      resource: "TypeDeviceInterphone",
      action: "read",
    },
    component: () => import("@/views/iotcomms/type_device_interphone/Index.vue"),
  },
  {
    path: "/device_interphone",
    name: "device_interphone",
    meta: {
      resource: "DeviceInterphone",
      action: "read",
    },
    component: () => import("@/views/iotcomms/device_interphone/Index.vue"),
  },
  {
    path: "/sip_call",
    name: "sip_call",
    meta: {
      resource: "SipCall",
      action: "read",
    },
    component: () => import("@/views/sip_call/Index.vue"),
  },
  {
    path: "/type_alarm",
    name: "type_alarm",
    meta: {
      resource: "TypeAlarm",
      action: "read",
    },
    component: () => import("@/views/alarm/type_alarm/Index.vue"),
  },
  {
    path: "/type_alarm_category",
    name: "type_alarm_category",
    meta: {
      resource: "TypeAlarmCategory",
      action: "read",
    },
    component: () => import("@/views/alarm/type_alarm_category/Index.vue"),
  },
  {
    path: "/alarm_level",
    name: "alarm_level",
    meta: {
      resource: "AlarmLevel",
      action: "read",
    },
    component: () => import("@/views/alarm/alarm_level/Index.vue"),
  },
  {
    path: "/command",
    name: "command",
    meta: {
      resource: "Command",
      action: "read",
    },
    component: () => import("@/views/command/Index.vue"),
  },
  {
    path: "/command/custom/:id_command?",
    name: "customCommand",
    meta: {
      resource: "Command",
      action: "read",
    },
    component: () => import("@/views/command/Config.vue"),
  },
  {
    path: "/command/logs",
    name: "commandLogs",
    meta: {
      resource: "Command",
      action: "read",
    },
    component: () => import("@/views/command/logs/Index.vue"),
  },
  {
    path: "/action-plan/logs",
    name: "actionPlanLogs",
    meta: {
      resource: "ActionPlan",
      action: "read",
    },
    component: () => import("@/views/action_plan/logs/Index.vue"),
  },
  {
    path: "/region",
    name: "region",
    meta: {
      resource: "Region",
      action: "read",
    },
    component: () => import("@/views/region/Index.vue"),
  },
  {
    path: "/log_incident",
    name: "log_incident",
    meta: {
      resource: "LogIncident",
      action: "read",
    },
    component: () => import("@/views/tenant/log_incident/Index.vue"),
  },
  {
    path: "/external_token/:id_user",
    name: "external_token",
    meta: {
      resource: "ExternalToken",
      action: "read",
    },
    component: () => import("@/views/user/external_token/Index.vue"),
  },
  {
    path: "/external_user/:id_user",
    name: "external_user",
    meta: {
      resource: "ExternalUser",
      action: "read",
    },
    component: () => import("@/views/user/external_user/Index.vue"),
  },
  {
    path: "/server",
    name: "server",
    meta: {
      resource: "IntelexvisionServer",
      action: "read",
    },
    component: () => import("@/views/intelexvision/server/Index.vue"),
  },
  {
    path: "/unit-groups",
    name: "unit_groups",
    meta: {
      resource: "UnitGroups",
      action: "read",
    },
    component: () => import("@/views/unit_groups/Index.vue"),
  },
  {
    path: "/unit-groups/config/:id_units_group?",
    name: "unit_groups_config",
    meta: {
      resource: "UnitGroups",
      action: "read",
    },
    component: () => import("@/views/unit_groups/Config.vue"),
  },
  {
    path: "/intelexvision_alarm_type",
    name: "intelexvision_alarm_type",
    meta: {
      resource: "IntelexvisionAlarmType",
      action: "read",
    },
    component: () => import("@/views/intelexvision/alarm_type/Index.vue"),
  },
  {
    path: "/analytic_record",
    name: "analytic_record",
    meta: {
      resource: "AnalyticRecord",
      action: "read",
    },
    component: () => import("@/views/intelexvision/analytic_record/Index.vue"),
  },
  {
    path: "/omnicloud_master_account",
    name: "omnicloud_master_account",
    meta: {
      resource: "OmnicloudMasterAccount",
      action: "read",
    },
    component: () => import("@/views/vxg_camera/master_account/Index.vue"),
  },
  {
    path: "/securos_master_account",
    name: "securos_master_account",
    meta: {
      resource: "SecurosMasterAccount",
      action: "read",
    },
    component: () => import("@/views/securos_camera/master_account/Index.vue"),
  },
  {
    path: "/countries",
    name: "countries",
    meta: {
      resource: "Countries",
      action: "read",
    },
    component: () => import("@/views/countries/Index.vue"),
  },
  {
    path: "/luna_master_account",
    name: "luna_master_account",
    meta: {
      resource: "LunaMasterAccount",
      action: "read",
    },
    component: () => import("@/views/luna/master_account/Index.vue"),
  },
  {
    path: "/luna_list",
    name: "luna_list",
    meta: {
      resource: "LunaList",
      action: "read",
    },
    component: () => import("@/views/luna/list/Index.vue"),
  },
  {
    path: "/luna_face",
    name: "luna_face",
    meta: {
      resource: "LunaFace",
      action: "read",
    },
    component: () => import("@/views/luna/face/Index.vue"),
  },
  {
    path: "/alarm_purge",
    name: "alarm_purge",
    meta: {
      resource: "PurgeAlarm",
      action: "read",
    },
    component: () => import("@/views/alarm/purge_alarm/Index.vue"),
  },
  {
    path: "/video/:alarm/:token",
    name: "video",
    component: () => import("@/views/pages/Video.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      redirectIfLoggedIn: true,
    },
  },
  {
    path: "/stream",
    name: "stream",
    component: () => import("@/views/pages/Stream.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      redirectIfLoggedIn: true,
    },
  },
  {
    path: "/schedule_alarm",
    name: "schedule_alarm",
    meta: {
      resource: "ScheduleAlarm",
      action: "read",
    },
    component: () => import("@/views/schedule_alarm/Index.vue"),
  },
  {
    path: "/popup-camera",
    name: "popup-camera",
    component: () => import("@/views/pages/PopupCamera.vue"),
    meta: {
      layout: "full",
      resource: "Home",
      redirectIfLoggedIn: false,
    },
  },
  {
    path: "/dahua_dvr",
    name: "dahua_dvr",
    meta: {
      resource: "DahuaDvr",
      action: "read",
    },
    component: () => import("@/views/dahua/dvr/Index.vue"),
  },
  {
    path: "/dahua_camera",
    name: "dahua_camera",
    meta: {
      resource: "DahuaCamera",
      action: "read",
    },
    component: () => import("@/views/dahua/camera/Index.vue"),
  },
  {
    path: "/hanwha_dvr",
    name: "hanwha_dvr",
    meta: {
      resource: "HanwhaDvr",
      action: "read",
    },
    component: () => import("@/views/hanwha/dvr/Index.vue"),
  },
  {
    path: "/hanwha_camera",
    name: "hanwha_camera",
    meta: {
      resource: "HanwhaCamera",
      action: "read",
    },
    component: () => import("@/views/hanwha/camera/Index.vue"),
  },
  {
    path: "/hanwha_alarm_profiles",
    name: "hanwha_alarm_profiles",
    meta: { resource: "HanwhaAlarmProfile", action: "read" },
    component: () => import("@/views/hanwha/alarm_profile/Index.vue"),
  },
  {
    path: "/hanwha_alarm_profiles/:profileId/rules",
    name: "hanwha_alarm_rules",
    meta: { resource: "HanwhaAlarmRule", action: "read" },
    component: () => import("@/views/hanwha/alarm_rule/Index.vue"),
  },
  {
    path: "/hanwha_logs",
    name: "hanwha_logs",
    meta: {
      resource: "HanwhaCamera",
      action: "read",
    },
    component: () => import("@/views/hanwha/log/Index.vue"),
  },
  {
    path: "/hikvision_master_accounts",
    name: "hikvision_master_accounts",
    meta: {
      resource: "HikvisionMasterAccount",
      action: "read",
    },
    component: () => import("@/views/hikvision/master_account/Index.vue"),
  },
  {
    path: "/hikvision_dvr",
    name: "hikvision_dvr",
    meta: {
      resource: "HikvisionDvr",
      action: "read",
    },
    component: () => import("@/views/hikvision/dvr/Index.vue"),
  },
  {
    path: "/hikvision_cameras",
    name: "hikvision_cameras",
    meta: {
      resource: "HikvisionCamera",
      action: "read",
    },
    component: () => import("@/views/hikvision/camera/Index.vue"),
  },
  {
    path: "/density_master_account",
    name: "density_master_account",
    meta: {
      resource: "DensityMasterAccount",
      action: "read",
    },
    component: () => import("@/views/density_master_account/Index.vue"),
  },
  {
    path: "/density_devices",
    name: "density_device",
    meta: {
      resource: "DensityDevice",
      action: "read",
    },
    component: () => import("@/views/density_device/Index.vue"),
  },
  {
    path: "/detection_event",
    name: "detection_event",
    meta: {
      resource: "DetectionEvent",
      action: "read",
    },
    component: () => import("@/views/detection_event/Index.vue"),
  },
  {
    path: "/ms_detection_event",
    name: "ms_detection_event",
    meta: {
      resource: "DetectionEvent",
      action: "read",
    },
    component: () => import("@/views/ms_detection_event/Index.vue"),
  },
  {
    path: "/omniview_reseller",
    name: "omniview_reseller",
    meta: {
      resource: "OmniviewReseller",
      action: "read",
    },
    component: () => import("@/views/omniview_reseller/Index.vue"),
  },
  {
    path: "/omniview_reseller_assignment",
    name: "omnia_reseller_assignment",
    meta: {
      resource: "OmniviewReseller",
      action: "read",
    },
    component: () => import("@/views/omniview_reseller/camera_assignment/Index.vue"),
  },
  {
    path: "/municipality",
    name: "municipality",
    meta: {
      resource: "Municipality",
      action: "read",
    },
    component: () => import("@/views/municipality/Index.vue"),
  },
  {
    path: "/recording_request_stream",
    name: "recording_request_stream",
    component: () => import("@/views/pages/RecordingRequestStream.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      redirectIfLoggedIn: true,
    },
  },
  {
    path: "/luna_facestream",
    name: "luna_facestream",
    meta: {
      resource: "LunaFacestream",
      action: "read",
    },
    component: () => import("@/views/luna/facestream/Index.vue"),
  },
  {
    path: "/generic_devices",
    name: "generic_devices",
    meta: {
      resource: "GenericDevice",
      action: "read",
    },
    component: () => import("@/views/generic_devices/devices/Index.vue"),
  },
  {
    path: "/microservice_logs",
    name: "microservice_logs",
    meta: {
      resource: "MicroserviceLogs",
      action: "read",
    },
    component: () => import("@/views/microservice_logs/Index.vue"),
  },
  // Maintenance
  {
    path: "/maintenance_company",
    name: "maintenance_company",
    meta: {
      resource: "MaintenanceCompany",
      action: "read",
    },
    component: () => import("@/views/maintenance/Index.vue"),
  },
  {
    path: "/maintenance_crew",
    name: "maintenance_crew",
    meta: {
      resource: "MaintenanceCompany",
      action: "read",
    },
    component: () => import("@/views/maintenance_crew/Index.vue"),
  },
  {
    path: "/service_orders",
    name: "service_orders",
    meta: {
      resource: "ServiceOrder",
      action: "read",
    },
    component: () => import("@/views/service_orders/Index.vue"),
  },
  // Maintenance app ---------
  {
    path: "/maintenance",
    name: "maintenance_index",
    meta: {
      resource: "Layouts",
      action: "read",
    },
    component: () => import("@/views/maintenance_index/Index.vue")
  },
  {
    path: "/maintenance/templates",
    name: "maintenanceTemplates",
    meta: {
      resource: "MaintenanceTemplate",
      action: "read",
    },
    component: () => import("@/views/maintenance/templates/Index.vue"),
  },
  {
    path: "/maintenancep/templates/builder",
    name: "configMaintenanceTemplate",
    meta: {
      resource: "MaintenanceTemplate",
      action: "create",
    },
    component: () => import("@/views/maintenance/templates/TemplateConfig.vue"),
  },
  {
    path: "/maintenance/templates/builder/:id_template?",
    name: "configMaintenanceTemplateEdit",
    meta: {
      resource: "MaintenanceTemplate",
      action: "edit",
    },
    component: () => import("@/views/maintenance/templates/TemplateConfig.vue"),
  },
  {
    path: "/maintenance/forms",
    name: "maintenanceForms",
    meta: {
      resource: "MaintenanceForm",
      action: "read",
    },
    component: () => import("@/views/maintenance/forms/Index.vue"),
  },
  {
    path: "/maintenance/forms/:id_form",
    name: "maintenanceFormsEdit",
    meta: {
      resource: "MaintenanceForm",
      action: "update",
    },
    component: () => import("@/views/maintenance/forms/ShowForm.vue"),
  },
  {
    path: "/share_video_link/:data",
    name: "share_video_link",
    component: () => import("@/views/share_video_link/Index.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      redirectIfLoggedIn: false,
    },
  },
  {
    path: "/validate_signature",
    name: "validate_signature",
    meta: {
      resource: "ValidateSignature",
      action: "read",
    },
    component: () => import("@/views/validate_signature/Index.vue"),
  },
  {
    path: "/set_password/:token",
    name: "set_password",
    meta: {
      layout: "full",
      resource: "Auth",
      action: "read",
    },
    component: () => import("@/views/pages/SetPassword.vue"),
  },
  {
    path: "/pacom_master_accounts",
    name: "pacom_master_accounts",
    meta: {
      resource: "PacomMasterAccounts",
      action: "read",
    },
    component: () => import("@/views/pacom/pacom_master_accounts/Index.vue"),
  },
  {
    path: "/pacom_sites",
    name: "pacom_sites",
    meta: {
      resource: "PacomSites",
      action: "read",
    },
    component: () => import("@/views/pacom/pacom_sites/Index.vue"),
  },
  {
    path: "/pacom_sites/:id/devices",
    name: "pacom_entries_actions",
    meta: {
      resource: "PacomSites",
      action: "read",
    },
    component: () => import("@/views/pacom/pacom_sites/Devices.vue"),
  },
  {
    path: "/pacom_schema_actions",
    name: "pacom_schema_actions",
    meta: {
      resource: "PacomActions",
      action: "read",
    },
    component: () => import("@/views/pacom/pacom_schema_actions/Index.vue"),
  },
  {
    path: "/pacom_schema_types",
    name: "pacom_schema_types",
    meta: {
      resource: "PacomSchemaTypes",
      action: "read",
    },
    component: () => import("@/views/pacom/pacom_schema_types/Index.vue"),
  },
  {
    path: "/pacom_devices",
    name: "pacom_devices",
    meta: {
      resource: "PacomEntries",
      action: "read",
    },
    component: () => import("@/views/pacom/pacom_devices/Index.vue"),
  },
  {
    path: "/pacom_alarm_types",
    name: "pacom_alarm_types",
    meta: {
      resource: "PacomEntries",
      action: "read",
    },
    component: () => import("@/views/pacom/pacom_alarm_types/Index.vue"),
  },
  {
    path: "/pacom_alarms",
    name: "pacom_alarms",
    meta: {
      resource: "PacomEntries",
      action: "read",
    },
    component: () => import("@/views/pacom/pacom_alarms/Index.vue"),
  },
  {
    path: "/pacom_logs",
    name: "pacom_logs",
    meta: {
      resource: "PacomEntries",
      action: "read",
    },
    component: () => import("@/views/pacom/pacom_logs/Index.vue"),
  },
  {
    path: "/intelbras/panels",
    name: "intelbras_panels",
    meta: {
      resource: "Intelbras",
      action: "read",
    },
    component: () => import("@/views/intelbras/intelbras_panels/Index.vue"),
  },
  {
    path: "/intelbras/panels/:id/devices",
    name: "intelbras_panels_devices",
    meta: {
      resource: "Intelbras",
      action: "read",
    },
    component: () => import("@/views/intelbras/intelbras_panels/Devices.vue"),
  },
  {
    path: "/intelbras/profiles",
    name: "intelbras_profiles",
    meta: {
      resource: "Intelbras",
      action: "read",
    },
    component: () => import("@/views/intelbras/intelbras_profiles/Index.vue"),
  },
  {
    path: "/intelbras/profiles/:id_intelbras_profile/rules",
    name: "intelbras_profiles_rules",
    meta: {
      resource: "Intelbras",
      action: "read",
    },
    component: () => import("@/views/intelbras/intelbras_rules/Index.vue"),
  },
  {
    path: "/intelbras/alarms",
    name: "intelbras_alarms",
    meta: {
      resource: "Intelbras",
      action: "read",
    },
    component: () => import("@/views/intelbras/intelbras_alarms/Index.vue"),
  },
  {
    path: "/intelbras/logs",
    name: "intelbras_logs",
    meta: {
      resource: "Intelbras",
      action: "read",
    },
    component: () => import("@/views/intelbras/intelbras_logs/Index.vue"),
  },
  {
    path: "/dmp/panels",
    name: "dmp_panels",
    meta: {
      resource: "Dmp",
      action: "read",
    },
    component: () => import("@/views/dmp/dmp_panels/Index.vue")
  },
  {
    path: "/dmp/logs",
    name: "dmp_logs",
    meta: {
      resource: "Dmp",
      action: "read",
    },
    component: () => import("@/views/dmp/dmp_logs/Index.vue")
  },
  {
    path: "/dmp/alarms",
    name: "dmp_alarms",
    meta: {
      resource: "Dmp",
      action: "read",
    },
    component: () => import("@/views/dmp/dmp_alarms/Index.vue")
  },
  {
    path: "/dmp/templates",
    name: "dmp_templates",
    meta: {
      resource: "Dmp",
      action: "read",
    },
    component: () => import("@/views/dmp/dmp_templates/Index.vue")
  },
  {
    path: "/dmp/panels/:id/devices",
    name: "dmp_panels_devices",
    meta: {
      resource: "Dmp",
      action: "read",
    },
    component: () => import("@/views/dmp/dmp_panels/Devices.vue")
  },
  {
    path: "/dmp/panels/:id/config",
    name: "dmp_panels_config",
    meta: {
      resource: "Dmp",
      action: "read",
    },
    props: true,
    component: () => import("@/views/dmp/dmp_panels/config/Index.vue")
  },
  {
    path: "/dmp/templates/:id/config",
    name: "dmp_templates_config",
    meta: {
      resource: "Dmp",
      action: "read",
    },
    props: (route) => ({ id: route.params.id, source: "template" }),
    component: () => import("@/views/dmp/dmp_panels/config/Index.vue")
  },
  {
    path: "/dmp/profiles",
    name: "dmp_profiles",
    meta: {
      resource: "Dmp",
      action: "read",
    },
    component: () => import("@/views/dmp/dmp_profiles/Index.vue")
  },
  {
    path: "/dmp/profiles/:id_dmp_profile/rules",
    name: "dmp_profiles_rules",
    meta: {
      resource: "Dmp",
      action: "read",
    },
    component: () => import("@/views/dmp/dmp_rules/Index.vue")
  },
  {
    path: "/dmp/servers",
    name: "dmp_servers",
    meta: {
      resource: "Dmp",
      action: "read",
    },
    component: () => import("@/views/dmp/dmp_servers/Index.vue")
  },
  {
    path: "/bosch/panels",
    name: "bosch_panels",
    meta: {
      resource: "BoschPanel",
      action: "read",
    },
    component: () => import("@/views/bosch/bosch_panels/Index.vue")
  },
  {
    path: "/bosch/panels/:id/devices",
    name: "bosch_panels_devices",
    meta: {
      resource: "BoschPanel",
      action: "read",
    },
    component: () => import("@/views/bosch/bosch_panels/devices/Index.vue")
  },
  {
    path: "/bosch/logs",
    name: "bosch_logs",
    meta: {
      resource: "BoschPanel",
      action: "read",
    },
    component: () => import("@/views/bosch/bosch_logs/Index.vue")
  },
  {
    path: "/bosch/profiles",
    name: "bosch_profiles",
    meta: {
      resource: "BoschPanel",
      action: "read",
    },
    component: () => import("@/views/bosch/bosch_profiles/Index.vue")
  },
  {
    path: "/bosch/profiles/:id_bosch_profile/rules",
    name: "bosch_profiles_rules",
    meta: {
      resource: "BoschPanel",
      action: "read",
    },
    component: () => import("@/views/bosch/bosch_rules/Index.vue")
  },
  {
    path: "/tenants_storage",
    name: "tenants_storage",
    meta: {
      resource: "Filesystem",
      action: "read",
    },
    component: () => import("@/views/tenant/tenants_storage/Index.vue"),
  },
  {
    path: "/tenant_files/:id_tenant",
    name: "tenant_files",
    meta: {
      resource: "Filesystem",
      action: "read",
    },
    component: () => import("@/views/tenant/files/Index.vue"),
  },
  {
    path: "/storage_provider",
    name: "storage_provider",
    meta: {
      resource: "Filesystem",
      action: "read",
    },
    component: () => import("@/views/storage_provider/Index.vue"),
  },
  {
    path: "/tenant_files_explorer",
    name: "tenant_files_explorer",
    meta: {
      resource: "Filesystem",
      action: "read",
    },
    component: () => import("@/views/tenant/files/explorer/Index.vue"),
  },
    {
    path: "/tenant_storage_provider/:id_tenant/:name_tenant",
    name: "tenant_storage_provider",
    meta: {
      resource: "Filesystem",
      action: "read",
    },
    component: () => import("@/views/tenant/tenant_storage_provider/Index.vue"),
  },
  {
    path: "/helpdesk_group",
    name: "helpdesk_group",
    meta: {
      resource: "HelpdeskGroup",
      action: "read",
    },
    component: () => import("@/views/helpdesk/group/Index.vue"),
  },
  {
    path: "/helpdesk_ticket",
    name: "helpdesk_ticket",
    meta: {
      resource: "HelpdeskTicket",
      action: "read",
    },
    component: () => import("@/views/helpdesk/ticket/Index.vue"),
  },
  {
    path: "/helpdesk_ticket_types",
    name: "helpdesk_ticket_types",
    meta: {
      resource: "HelpdeskTicketType",
      action: "read",
    },
    component: () => import("@/views/helpdesk/ticket_types/Index.vue"),
  },
  {
    path: "/proxy_rtsp_server",
    name: "proxy_rtsp_server",
    meta: {
      resource: "ProxyRtspServer",
      action: "read",
    },
    component: () => import("@/views/generic_devices/proxy_rtsp_servers/Index.vue"),
  },
  {
    path: "/pbx_master_account",
    name: "pbx_master_account",
    meta: {
      resource: "PbxMasterAccount",
      action: "read",
    },
    component: () => import("@/views/pbx/master_account/Index.vue"),
  },
  {
    path: "/pbx_device",
    name: "pbx_device",
    meta: {
      resource: "PbxDevice",
      action: "read",
    },
    component: () => import("@/views/pbx/device/Index.vue"),
  },
  {
    path: "/pbx_ip_block",
    name: "pbx_ip_block",
    meta: {
      resource: "PbxMasterAccount",
      action: "read",
    },
    component: () => import("@/views/pbx/ip_block/Index.vue"),
  },
  {
    path: "/pbx_call",
    name: "pbx_call",
    meta: {
      resource: "PbxCall",
      action: "read",
    },
    component: () => import("@/views/pbx/call/Index.vue"),
  },
  {
    path: "/document_action_plan",
    name: "document_action_plan",
    meta: {
      resource: "ActionPlan",
      action: "read",
    },
    component: () => import("@/views/action_plan_document/Index.vue"),
  },
  {
    path: "/risk/evaluations",
    name: "risk_evaluations",
    meta: {
      resource: "RiskEvaluation",
      action: "read",
    },
    component: () => import("@/views/risk/evaluations/Index.vue"),
  },
  {
    path: "/risk/bau-complements",
    name: "risk_bau_complements",
    meta: {
      resource: "BauComplement",
      action: "read",
    },
    component: () => import("@/views/risk/bau_complements/Index.vue"),
  },
  {
    path: "/risk/bau-complements/templates",
    name: "risk_bau_complement_templates",
    meta: {
      resource: "OperationalProcedureTemplate",
      action: "read",
    },
    component: () => import("@/views/risk/bau_complements/templates/Index.vue"),
  },
  {
    path: "/risk/bau-complements/templates/builder",
    name: "configBauComplementTemplate",
    meta: {
      resource: "OperationalProcedureTemplate",
      action: "create",
    },
    component: () => import("@/views/risk/bau_complements/templates/TemplateConfig.vue"),
  },
  {
    path: "/risk/bau-complements/templates/builder/:id_template?",
    name: "configBauComplementTemplateEdit",
    meta: {
      resource: "OperationalProcedureTemplate",
      action: "update",
    },
    component: () => import("@/views/risk/bau_complements/templates/TemplateConfig.vue"),
  },
  {
    path: "/risk/simulacrums",
    name: "risk_simulacrums",
    meta: {
      resource: "Simulacrum",
      action: "read",
    },
    component: () => import("@/views/risk/simulacrums/Index.vue"),
  },
  {
    path: "/risk/operational_procedure/templates",
    name: "risk_operational_procedure_templates",
    meta: {
      resource: "OperationalProcedureTemplate",
      action: "read",
    },
    component: () => import("@/views/risk/operational_procedure/templates/Index.vue"),
  },
  {
    path: "/risk/operational_procedure/templates/builder",
    name: "configOperationalProcedureTemplate",
    meta: {
      resource: "OperationalProcedureTemplate",
      action: "create",
    },
    component: () => import("@/views/risk/operational_procedure/templates/TemplateConfig.vue"),
  },
  {
    path: "/risk/operational_procedure/templates/builder/:id_template?",
    name: "configOperationalProcedureTemplateEdit",
    meta: {
      resource: "OperationalProcedureTemplate",
      action: "update",
    },
    component: () => import("@/views/risk/operational_procedure/templates/TemplateConfig.vue"),
  },
  {
    path: "/risk/operational_procedure",
    name: "risk_operational_procedure",
    meta: {
      resource: "OperationalProcedure",
      action: "read",
    },
    component: () => import("@/views/risk/operational_procedure/Index.vue"),
  },
  {
    path: "/risk/simulacrums/templates",
    name: "simulacrumTemplates",
    meta: {
      resource: "SimulacrumTemplate",
      action: "read",
    },
    component: () => import("@/views/risk/simulacrums/templates/Index.vue"),
  },
  {
    path: "/risk/simulacrums/templates/builder",
    name: "configSimulacrumTemplate",
    meta: {
      resource: "SimulacrumTemplate",
      action: "create",
    },
    component: () => import("@/views/risk/simulacrums/templates/TemplateConfig.vue"),
  },
  {
    path: "/risk/simulacrums/templates/builder/:id_template?",
    name: "configSimulacrumTemplateEdit",
    meta: {
      resource: "SimulacrumTemplate",
      action: "update",
    },
    component: () => import("@/views/risk/simulacrums/templates/TemplateConfig.vue"),
  },
  // Template Risk Builder
  {
    path: "/risk/templates",
    name: "riskTemplates",
    meta: {
      resource: "RiskTemplate",
      action: "read",
    },
    component: () => import("@/views/risk/templates/Index.vue"),
  },
  {
    path: "/risk/templates/builder",
    name: "configRiskTemplate",
    meta: {
      resource: "RiskTemplate",
      action: "create",
    },
    component: () => import("@/views/risk/templates/TemplateConfig.vue"),
  },
  {
    path: "/risk/templates/builder/:id_template?",
    name: "configRiskTemplateEdit",
    meta: {
      resource: "RiskTemplate",
      action: "update",
    },
    component: () => import("@/views/risk/templates/TemplateConfig.vue"),
  },
  // Template Security Self Audit
  {
    path: "/risk/security_self_audit/templates",
    name: "securitySelfAuditTemplates",
    meta: {
      resource: "SecuritySelfAuditTemplate",
      action: "read",
    },
    component: () => import("@/views/security_self_audit/templates/Index.vue"),
  },
  {
    path: "/risk/security_self_audit/templates/builder",
    name: "configSecuritySelfAuditTemplate",
    meta: {
      resource: "SecuritySelfAuditTemplate",
      action: "create",
    },
    component: () => import("@/views/security_self_audit/templates/TemplateConfig.vue"),
  },
  {
    path: "/risk/security_self_audit/templates/builder/:id_template?",
    name: "configSecuritySelfAuditTemplateEdit",
    meta: {
      resource: "SecuritySelfAuditTemplate",
      action: "update",
    },
    component: () => import("@/views/security_self_audit/templates/TemplateConfig.vue"),
  },
  //Security Self Audits
  {
    path: "/risk/security_self_audit/audits",
    name: "securitySelfAudits",
    meta: {
      resource: "SecuritySelfAudit",
      action: "read",
    },
    component: () => import("@/views/security_self_audit/audits/Index.vue"),
  },
  {
    path: "/reset-password/:data",
    name: "reset-password",
    component: () => import("@/views/user/reset_password/resetPassword.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      redirectIfLoggedIn: false,
    },
  },
  {
    path: "/ntechlab_master_account",
    name: "ntechlab_master_account",
    component: () => import("@/views/Ntechlab/MasterAccount/Index.vue"),
    meta: {
      resource: "NtechlabMasterAccount",
      action: "read",
    },
  },
  {
    path: "/ntechlab_watchlist",
    name: "ntechlab_watchlist",
    component: () => import("@/views/Ntechlab/WatchList/Index.vue"),
    meta: {
      resource: "NtechlabWatchlist",
      action: "read",
    },
  },
  {
    path: "/ntechlab_face_recognition",
    name: "ntechlab_face_recognition",
    component: () => import("@/views/Ntechlab/Face/Index.vue"),
    meta: {
      resource: "NtechlabFace",
      action: "read",
    },
  },
  {
    path: "/ntechlab_camera",
    name: "ntechlab_camera",
    component: () => import("@/views/Ntechlab/Camera/Index.vue"),
    meta: {
      resource: "NtechlabCamera",
      action: "read",
    },
  },
  // Alarm Microservice
  {
    path: "/alarm-rules",
    name: "alarm-rules",
    meta: {
      resource: "Alarm",
      action: "readrule",
    },
    component: () => import("@/views/alarm/rules/Index.vue"),
  },
  {
    path: "/alarm-rules/match-rules",
    name: "match-rules",
    meta: {
      resource: "Alarm",
      action: "createrule",
    },
    component: () => import("@/views/alarm/rules/RuleGrid.vue"),
  },
  {
    path: "/alarm-rules/match-rules/:id_rule?",
    name: "match-rules-edit",
    meta: {
      resource: "Alarm",
      action: "editrule",
    },
    component: () => import("@/views/alarm/rules/RuleGrid.vue"),
  },
  {
    path: "/institutions",
    name: "institutions",
    meta: {
      resource: "Institutions",
      action: "editrule",
    },
    component: () => import("@/views/institutions_tenant/Index.vue")
  },
  {
    path: "/facility_categories",
    name: "facility_categories",
    meta: {
      resource: "FacilityCategory",
      action: "read",
    },
    component: () => import("@/views/facility_categories/Index.vue"),
  },
  {
    path: "/unit_deactivation_catalog",
    name: "unit_deactivation_catalog",
    meta: {
      resource: "UnitDeactivationCatalog",
      action: "read",
    },
    component: () => import("@/views/unit_deactivation_catalog/Index.vue"),
  },
  {
    path: "/companies",
    name: "companies",
    meta: {
      resource: "Providers",
      action: "read",
    },
    component: () => import("@/views/companies/Index.vue")
  },
  {
    path: "/employees",
    name: "employees",
    meta: {
      resource: "Employees",
      action: "read",
    },
    component: () => import("@/views/employees/Index.vue")
  },
  {
    path: "/alarm-groups",
    name: "alarm-groups",
    meta: {
      resource: "AlarmGroups",
      action: "read",
    },
    component: () => import("@/views/alarm_group/Index.vue"),
  },
  // Operational safety
  {
    path: "/operational_security/templates",
    name: "operationalSecurityTemplates",
    meta: {
      resource: "OpSecurityFormTemplate",
      action: "read",
    },
    component: () => import("@/views/operational_security/templates/Index.vue"),
  },
  {
    path: "/operational_security/templates/builder",
    name: "configOperationalSecurityTemplate",
    meta: {
      resource: "OpSecurityFormTemplate",
      action: "create",
    },
    component: () => import("@/views/operational_security/templates/TemplateConfig.vue"),
  },
  {
    path: "/operational_security/templates/builder/:id_template?",
    name: "configOperationalSecurityTemplateEdit",
    meta: {
      resource: "OpSecurityFormTemplate",
      action: "update",
    },
    component: () => import("@/views/operational_security/templates/TemplateConfig.vue"),
  },
  {
    path: "/operational_security/form-answers",
    name: "OperationalSecurityFormAnswers",
    meta: {
      resource: "OpSecurityFormAnswers",
      action: "read",
    },
    component: () => import("@/views/operational_security/evaluations/Index.vue"),
  },
  {
    path: "/operational_security/form-answers-bau",
    name: "OperationalSecurityFormAnswersBau",
    meta: {
      resource: "BauComplement",
      action: "view_menu_form_answers",
    },
    component: () => import("@/views/operational_security/evaluations/Index.vue"),
  },
  // omnicloud RF
  {
    path: "/omnicloud_watchlist",
    name: "omnicloud_watchlist",
    component: () => import("@/views/omnicloud_fr/WatchList/Index.vue"),
    meta: {
      resource: "OmnicloudFrList",
      action: "read",
    },
  },
  {
    path: "/omnicloud_face_recognition",
    name: "omnicloud_face_recognition",
    component: () => import("@/views/omnicloud_fr/Face/Index.vue"),
    meta: {
      resource: "OmnicloudFrFaces",
      action: "read",
    },
  },
  {
    path: "/ai_analytics_servers/servers",
    name: "ai_analytics_servers",
    meta: {
      resource: "ai_analytics_servers",
      action: "read",
    },
    component: () => import("@/views/ai_analytics_servers/servers/Index.vue"),
  },
  {
    path: "/ai_analytics_servers/:id/devices",
    name: "ai_analytics_devices",
    meta: {
      resource: "ai_analytics_devices",
      action: "read",
    },
    component: () => import("@/views/ai_analytics_servers/devices/Index.vue"),
  },
  {
    path: "/ai_analytics_servers/logs",
    name: "ai_analytics_servers_logs",
    meta: {
      resource: "ai_analytics_servers_logs",
      action: "read",
    },
    component: () => import("@/views/ai_analytics_servers/logs/Index.vue"),
  },
  // testing(forms) module
  {
    path: "/testing/penetration",
    name: "penetrationTesting",
    meta: {
      resource: "Testing",
      action: "read",
    },
    component: () => import("@/views/testing/penetration/Index.vue"),
  },
  {
    path: "/testing/security_box",
    name: "securityBoxTesting",
    meta: {
      resource: "Testing",
      action: "read",
    },
    component: () => import("@/views/testing/security_box/Index.vue"),
  },
  {
    path: "/planning",
    name: "planning",
    meta: {
      resource: "Planning",
      action: "read",
    },
    component: () => import("@/views/planning/Index.vue"),
  },
  {
    path: "/planning/create",
    name: "planningCreate",
    meta: {
      resource: "Planning",
      action: "create",
    },
    component: () => import("@/views/planning/Form.vue"),
  },
  {
    path: "/planning/:id",
    name: "planningEdit",
    meta: {
      resource: "Planning",
      action: "update",
    },
    component: () => import("@/views/planning/Form.vue"),
  },
  {
    path: "/policy-exceptions",
    name: "policyExceptions",
    meta: {
      resource: "PolicyException",
      action: "read",
    },
    component: () => import("@/views/policyException/Index.vue"),
  },
  {
    path: "/policy-exceptions/create",
    name: "policyExceptionCreate",
    meta: {
      resource: "PolicyException",
      action: "create",
    },
    component: () => import("@/views/policyException/Create.vue"),
  },
  {
    path: "/policy-exceptions/:id",
    name: "policyExceptionEdit",
    meta: {
      resource: "PolicyException",
      action: "update",
    },
    component: () => import("@/views/policyException/Create.vue"),
  },
  {
    path: "/custom-timezones",
    name: "custom_timezones",
    meta: {
      resource: "custom_timezones",
      action: "read",
    },
    component: () => import("@/views/custom_timezones/Index.vue"),
  },
  // training (forms) module
  {
    path: "/training",
    name: "trainingModule",
    meta: {
      resource: "Trainings",
      action: "read",
    },
    component: () => import("@/views/training/Index.vue"),
  },
  {
    path: "/dmp/user-code/:token",
    name: "dmp_user_code",
    component: () => import("@/views/dmp/dmp_user_code/Index.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      redirectIfLoggedIn: false,
    },
  },
  {
    path: "/operational-security/crisis-form",
    name: "crisis_form",
    meta: {
      resource: "CrisisForm",
      action: "read",
    },
    component: () => import("@/views/operational_security/crisis_form/Index.vue"),
  },
  {
    path: "/operational-security/crisis-form/create",
    name: "crisis_form_create",
    meta: {
      resource: "CrisisForm",
      action: "create",
    },
    component: () => import("@/views/operational_security/crisis_form/CrisisForm.vue"),
  },
  {
    path: "/operational-security/crisis-form/:id/edit",
    name: "crisis_form_edit",
    meta: {
      resource: "CrisisForm",
      action: "update",
    },
    component: () => import("@/views/operational_security/crisis_form/CrisisForm.vue"),
  },
  {
    path: "/operational_security/external_personnel_access_control",
    name: "external_personnel_access_control",
    meta: {
      resource: "ExternalPersonnelAccessControl",
      action: "read",
    },
    component: () => import("@/views/operational_security/operational_processes/Index.vue"),
  },
  {
    path: "/operational_security/crisis_form/Damages",
    name: "crisis_form_damages",
    meta: {
      resource: "CrisisForm",
      action: "read",
    },
    component: () => import("@/views/operational_security/crisis_form/Damages.vue"),
  },
  {
    path: "/operational_security/crisis_form/MasterData",
    name: "crisis_form_master_data",
    meta: {
      resource: "CrisisForm",
      action: "read",
    },
    component: () => import("@/views/operational_security/crisis_form/MasterData.vue"),
  },
  {
    path: "/teams",
    name: "teams",
    meta: {
      resource: "Teams",
      action: "read",
    },
    component: () => import("@/views/teams/Index.vue"),
  },
  {
    path: "/directory",
    name: "directory",
    meta: {
      resource: "Directory",
      action: "read",
    },
    component: () => import("@/views/directory/Index.vue"),
  },
  {
    path: "/unit-floors",
    name: "unit-floors",
    meta: {
      resource: "UnitFloor",
      action: "read",
    },
    component: () => import("@/views/pisos/Index.vue"),
  },
  {
    path: "/brigades",
    name: "brigades",
    meta: {
      resource: "Brigade",
      action: "read",
    },
    component: () => import("@/views/brigades/Index.vue"),
  },
  {
    path: "/patrol_logs",
    name: "patrol_logs",
    meta: {
      resource: "PatrolLogs",
      action: "read",
    },
    component: () => import("@/views/patrol_logs/patrol_log/Index.vue"),
  },
  {
    path: "/patrol_logs/unit_log",
    name: "unit_log",
    meta: {
      resource: "UnitLogs",
      action: "read",
    },
    component: () => import("@/views/patrol_logs/unit_log/Index.vue"),
  },
  {
    path: "/patrol_logs/unit_commanders",
    name: "unit_commanders",
    meta: {
      resource: "UnitCommanders",
      action: "read",
    },
    component: () => import("@/views/patrol_logs/unit_commander/Index.vue"),
  },
  {
    path: "/patrol_logs/revision_codes",
    name: "revision_codes",
    meta: {
      resource: "RevisionCodes",
      action: "read",
    },
    component: () => import("@/views/patrol_logs/revision_code/Index.vue"),
  },
  {
    path: "/hollidays",
    name: "hollidays",
    meta: {
      resource: "Holliday",
      action: "read",
    },
    component: () => import("@/views/hollidays/Index.vue"),
  },
  {
    path: "/inventory",
    name: "inventory",
    meta: {
      resource: "Inventory",
      action: "read",
    },
    component: () => import("@/views/inventory/Index.vue"),
  },
  {
    path: "/inventory/catalogs/brands",
    name: "inventory_brand_catalog",
    meta: {
      resource: "InventoryBrandCatalog",
      action: "read",
    },
    component: () => import("@/views/inventory_brands_catalog/Index.vue"),
  },
  {
    path: "/inventory/catalogs/equipment-types",
    name: "inventory_equipment_type_catalog",
    meta: {
      resource: "InventoryEquipmentTypeCatalog",
      action: "read",
    },
    component: () => import("@/views/inventory_equipment_types_catalog/Index.vue"),
  },
  {
    path: "/inventory/catalogs/projects",
    name: "inventory_project_catalog",
    meta: {
      resource: "InventoryProjectCatalog",
      action: "read",
    },
    component: () => import("@/views/inventory_projects_catalog/Index.vue"),
  },
  {
    path: "/billing/holidays",
    name: "billing_holiday",
    meta: {
      resource: "BillingHoliday",
      action: "read",
    },
    component: () => import("@/views/billing_holiday/Index.vue"),
  },
  {
    path: "/billing/prices",
    name: "billing_price",
    meta: {
      resource: "BillingPrice",
      action: "read",
    },
    component: () => import("@/views/billing_price/Index.vue"),
  },
  {
    path: "/billing/finances",
    name: "billing_finance",
    meta: {
      resource: "BillingFinance",
      action: "read",
    },
    component: () => import("@/views/billing_finance/Index.vue"),
  },
    {
    path: "/user/assigned_regions",
    name: "user_assigned_regions",
    meta: {
      resource: "UserAssignedRegion",
      action: "read",
    },
    component: () => import("@/views/user_assigned_regions/Index.vue"),
    },
  {
    path: "/operational_security/activities",
    name: "external_personnel_access_control_activity",
    meta: {
      resource: "ExternalPersonnelAccessControlActivity",
      action: "read",
    },
    component: () => import("@/views/operational_security_activities/Index.vue"),
  },
  {
    path: "/totem_logs",
    name: "totem_logs",
    component: () => import("@/views/totem_logs/Index.vue"),
    meta: {
      resource: "TotemLogs",
      action: "read",
    },
  },
  {
    path: "/user/assigned_video_tours",
    name: "user_assigned_video_tours",
    meta: {
      resource: "UserAssignedVideoTour",
      action: "read",
    },
    component: () => import("@/views/user_assigned_video_tours/Index.vue"),
  },
  {
    path: "/user-shifts",
    name: "user-shifts",
    meta: {
      resource: "UserShifts",
      action: "read",
    },
    component: () => import("@/views/user_shifts/Index.vue"),
  },
  {
    path: "/users_rh",
    name: "users_rh",
    meta: {
      resource: "UserRh",
      action: "read",
    },
    component: () => import("@/views/users_rh/Index.vue"),
  },
  {
    path: "/user_group_selection_option",
    name: "user_group_selection_option",
    meta: {
      resource: "UserGroupSelectionOption",
      action: "read",
    },
    component: () => import("@/views/user_group_selection_option/Index.vue"),
  },
  {
    path: "/user_group_selection_option_history",
    name: "user_group_selection_option_history",
    meta: {
      resource: "UserGroupSelectionOptionHistory",
      action: "read",
    },
    component: () => import("@/views/user_group_selection_option_history/Index.vue"),
  },
  {
    path: "/victronenergy/master_account",
    name: "victronenergy_master_account",
    meta: {
      resource: "Victronenergy",
      action: "read",
    },
    component: () => import("@/views/victronenergy/master_account/Index.vue"),
  },
  {
    path: "/victronenergy/sites",
    name: "victronenergy_sites",
    meta: {
      resource: "Victronenergy",
      action: "read",
    },
    component: () => import("@/views/victronenergy/sites/Index.vue"),
  },
  {
    path: "/victronenergy/devices",
    name: "victronenergy_devices",
    meta: {
      resource: "Victronenergy",
      action: "read",
    },
    component: () => import("@/views/victronenergy/devices/Index.vue"),
  },
];
